// extracted by mini-css-extract-plugin
export default {"dynamicButtonContainer":"_dynamic-button_dynamicButtonContainer__RPOqf"};